window.addEventListener('scroll', () => {stickyHeader();});
window.addEventListener('resize', () => {contentTop();}, true);

const header = document.getElementById('shopify-section-header');
const sticky = header.offsetTop;

function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add('sticky--header');
    contentTop();
  } else {
    header.classList.remove('sticky--header');
    document.querySelector('#main-content').removeAttribute('style');
  }
}

function contentTop() {
  if (header.classList.contains('sticky--header')) {
    const mainContent = document.querySelector('.sticky--header + #main-content');
    mainContent.style.marginTop = header.offsetHeight + 'px';
  }
}